<template>
  <div class="crumbs-1">
    <div class="container">
      <a :href="crumbindexhref">首页</a>
      <span>&gt;</span>
      <router-link :to="linkhref">{{ name }}</router-link>
      <span v-show="detail">&gt;</span>
      <router-link to="" v-show="detail">详情页</router-link>
    </div>
  </div>
</template>

<script>
import menuConfig from '@/components/header/menuconfig'
export default {
  name: 'index',
  props: {
    detail: {
      default: false
    }
  },
  data () {
    return {
      name: '',
      linkhref: '',
      List: [],
      crumbindexhref: location.protocol + '//' + location.host
    }
  },
  computed: {
    menu () {
      return this.$store.state.menuTree.list
    },
    adSlot () {
      return this.$store.state.adSlot.list
    }
  },
  watch: {
    adSlot (val) {
      if (val) {
        this.List = val
        this.getData()
      }
    },
    menu (val) {
      let obj = this.recursion(val, this.$route.query.columnId)
      this.name = obj.title
      this.linkscreen(obj)
    }
  },
  mounted () {
    if (this.$store.state.menuTree.list.length !== 0) {
      let obj = this.recursion(this.$store.state.menuTree.list, this.$route.query.columnId)
      this.name = obj.title
      this.linkscreen(obj)
    }
    if (this.$store.state.adSlot.list.length !== 0) {
      this.List = this.$store.state.adSlot.list
      this.getData()
    }
  },
  methods: {
    getData () {
      this.List.forEach(item => {
        // 子首页配置列表页相应菜单
        if (item.slotName === 'subhomepage') {
          if (item.adDetails.length > 0) {
            item.adDetails.forEach(items => {
              if (items.adName === this.$route.query.subhomepage) {
                this.crumbindexhref = items.adLink
              }
            })
          }
        }
      })
    },
    linkscreen (obj) {
      if (this.$route.query.subhomepage !== undefined) {
        this.linkhref = '/' + menuConfig[obj.backRouteId] + '?columnId=' + obj.id + '&subhomepage=' + this.$route.query.subhomepage
      } else {
        this.linkhref = '/' + menuConfig[obj.backRouteId] + '?columnId=' + obj.id
      }
    },
    recursion (data, current) {
      let result = null
      if (!data) return
      for (var i in data) {
        if (result !== null) break
        let item = data[i]
        if (item.id === parseInt(current)) {
          result = item
          break
        } else if (item.children && item.children.length > 0) {
          result = this.recursion(item.children, current)
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.crumbs-1{
  color: #999;
  padding: 1.5% 0 0;
  text-align: right;
  @media only screen and (max-width: 768px){
    padding: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/crumbs/index.vue